import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = {
  lastBest: {
    list: [],
    page: 1,
    totalPage: 2,
    pageInfo: {}
  },
  detail: {},
  myOrder: {
    list: [],
    pageInfo: {
      page: 1,
      limit: 10,
      totalPage: 2
    }
  }
};
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
